import { ReportPDFAsset, ReportPDFReponse } from 'queries/report/contract';
import { PdfAssetCaptions } from '../components/Asset/PdfAssetCaptions/PdfAssetCaptions';
import CaseDetails from '../components/Cases/PdfCaseDetails';
import PdfPageTitle from '../components/PageTitle/PdfPageTitle';
import PageWrapper from '../components/PageWrapper/PageWrapper';
import { PdfAssetsList } from '../components/Asset/PdfAssetsList';

type AssetProps = {
  data: ReportPDFReponse;
  date: string;
  category: string;
};

function findAssetsWithCases(node: ReportPDFAsset): ReportPDFAsset | null {
  // If node has no children, just check if it has cases
  if (!node.children || node.children.length === 0) {
    if ('cases' in node && Array.isArray(node.cases) && node.cases.length > 0) {
      return { ...node, children: [] };
    }
    return null;
  }

  // Recursively filter children
  const filteredChildren = node.children
    .map((child) => findAssetsWithCases(child))
    .filter((child): child is ReportPDFAsset => child !== null);

  // If this node has cases or any filtered children, include it
  if (
    ('cases' in node && Array.isArray(node.cases) && node.cases.length > 0) ||
    filteredChildren.length > 0
  ) {
    return {
      ...node,
      children: filteredChildren,
    };
  }

  // Otherwise, exclude this node
  return null;
}

export const ThirdPage = ({ data, date, category }: AssetProps) => {
  const assetsWithCases = findAssetsWithCases(data);

  if (!assetsWithCases) {
    return null;
  }

  return (
    <PageWrapper
      assetName={data.name}
      date={date}
      category={category}
      assetDescription={data.description}
    >
      <PdfPageTitle pageNumber={3} />
      <PdfAssetCaptions />
      {PdfAssetsList({ data: assetsWithCases, casesComponent: CaseDetails, depth: 3 })}
    </PageWrapper>
  );
};
